import { useReschedulePatientAppointment } from '@/api/hooks/useReschedulePatientAppointment'
import { analytics } from '@/lib/analytics'
import { Button, ButtonText } from '@/ui/core/button'
import {
	Dialog,
	DialogClose,
	DialogContent,
	DialogDescription,
	DialogFooter,
	DialogHeader,
	DialogTitle,
	DialogTrigger,
} from '@/ui/core/dialog'
import { router } from 'expo-router'
import type { ReactNode } from 'react'
import { useState } from 'react'
import { Platform } from 'react-native'

const RescheduleConfirmationModal = ({
	appointmentId,
	children,
}: { appointmentId: number; children: ReactNode }) => {
	const [open, setOpen] = useState(false)
	const { mutate: rescheduleAppointment, isPending: isReschedulingAppointment } =
		useReschedulePatientAppointment()

	const onContinuePressed = () => {
		const schedulingWindow =
			Platform.OS === 'web' ? window.open(undefined, '_blank') : undefined

		rescheduleAppointment(
			{ appointmentId },
			{
				onSuccess: ({ rescheduleLinkUrl }) => {
					analytics.trackEvent('rescheduling-appointment', {
						appointmentId,
					})
					setOpen(false)
					const urlWithUtms = `${rescheduleLinkUrl}&utm_source=patient_app`

					if (Platform.OS === 'web') {
						schedulingWindow!.location = urlWithUtms
					} else {
						router.push({
							pathname: '/schedule-appointment',
							params: {
								scheduleUrl: urlWithUtms,
							},
						})
					}
				},
			}
		)
	}

	return (
		<Dialog open={open} onOpenChange={setOpen}>
			<DialogTrigger asChild>{children}</DialogTrigger>
			<DialogContent variant="info" contentClassName="gap-16">
				<DialogHeader>
					<DialogTitle>Just a heads up.</DialogTitle>
					<DialogDescription>
						By continuing, your current appointment will be cancelled, but you can book a
						new one right away.
					</DialogDescription>
				</DialogHeader>
				<DialogFooter className="items-center">
					<Button
						isLoading={isReschedulingAppointment}
						onPress={onContinuePressed}
						withArrow
					>
						<ButtonText>Continue</ButtonText>
					</Button>
					<DialogClose asChild>
						<Button size="xs" variant="ghostBorderless">
							<ButtonText spacing="wide">NEVERMIND</ButtonText>
						</Button>
					</DialogClose>
				</DialogFooter>
			</DialogContent>
		</Dialog>
	)
}

export { RescheduleConfirmationModal }
